<template>
    <div>
        <SubHeader :text="$t('h.vn')" :imgUrl="imgUrl" />
        <Content0 />
        <Content1 />
    </div>
</template>
<script>
import SubHeader from "@/components/SubHeader.vue";
import Content0 from "./Content0";
import Content1 from "./Content1";
import initAnimation from "../animation";
export default {
    data() {
        return {
            imgUrl: require("@/assets/images/sub_page_banner_3.jpg"),
        };
    },
    mounted() {
        setTimeout(initAnimation, 0);
    },
    components: {
        SubHeader,
        Content0,
        Content1,
    },
};
</script>



// WEBPACK FOOTER //
// src/Pages/Retail/Retail.vue